<template>
    <div class="width-full">
        <v-container fluid grid-list-xl class="container-symptoms-questions general-container">
            <v-layout row wrap class="navigation-header">
                <v-flex xs12>
                    <header-bar></header-bar>
                </v-flex>
            </v-layout>

                <v-layout row wrap class="evaluation-page-pf">
                    <v-flex lg4 offset-lg4 md8 offset-md2 sm8 offset-sm2 xs12 class="no-padding">
                        <p class="page-title-pf no-margin-bottom hidden-xs-only">{{text("api.pdf.pageTitle.scoring")}}</p>
                        <standard-stepper  :steps="step"></standard-stepper>
                        <description class="margin-top-xl"></description>

                </v-flex>
            </v-layout>


            <v-layout row wrap class="general-info with-alerts">

                <v-flex lg4 offset-lg4 md6 offset-md3 sm8 offset-sm2 xs12 class="evaluation-page-pf-content no-padding-right no-padding-left">

                    <v-card color="white" class="pf-evaluation-page">

                            <v-card-text v-if="evaluationData.hasScoringData" class="px-0 recommendations">
                                <div v-if="evaluationData.hasScoringData === false" class="color-headings-text font-size-medium no-recommendation">
                                    <p  class="no-margin-bottom">{{text("api.evaluation.noDecision")}}</p>
                                    <br />
                                </div>

                            <v-expansion-panel expand v-else >

                                <v-expansion-panel-content  v-if="evaluationData.decisions && evaluationData.hasScoringData" class="expansion-list decisions-container" value="1">
                                    <div slot="header" class="color-headings-text font-size-medium">
                                        {{text('db.product.PROD_SCORING')}}
                                    </div>
                                    <v-card>
                                        <v-card-text>
                                            <div v-if="evaluationData.decisions.decisionItem1">
                                                <h4>{{text('api.assessment.headline.di1')}}</h4>
                                                <h4 v-if="evaluationData.decisions.decisionItem1.headline && evaluationData.decisions.decisionItem1.text" v-bind:style="{'color': evaluationData.decisions.decisionItem1.color }"
                                                    v-html="evaluationData.decisions.decisionItem1.headline">
                                                </h4>
                                                <p v-if="evaluationData.decisions.decisionItem1.text" class="font-weight-regular" v-html="evaluationData.decisions.decisionItem1.text">
                                                </p>
                                                <br/>
                                            </div>
                                            <div v-if="evaluationData.decisions.decisionItems2">
                                                <h4>{{text('api.assessment.headline.di2')}}</h4>
                                                <div v-for="decisionItem2 in evaluationData.decisions.decisionItems2" >
                                                    <h4 v-if="decisionItem2.headline && decisionItem2.text"
                                                        v-bind:style="{'color': decisionItem2.color }"
                                                        v-html="decisionItem2.headline">
                                                    </h4>
                                                    <p  class="font-weight-regular no-margin-bottom">
                                                        <span v-if="decisionItem2.target === true" >
                                                             <img src="src/assets/svg/ambulance_alert_on.svg" alt="medicine logo" class="margin-left-xxs ambulance-scoring scoring-page" width="28" height="28">
                                                        </span>
                                                        <span v-html="decisionItem2.text"></span>
                                                    </p>
                                                </div>
                                            </div>
                                             <br/>
                                            <div v-if="evaluationData.decisions.decisionItems3">

                                                    <h4>{{text('api.assessment.headline.di3')}}</h4>
                                                    <div v-for="decisionItem3 in evaluationData.decisions.decisionItems3"  class="font-weight-regular no-margin-bottom">
                                                        <h4   v-bind:style="{'color': decisionItem3.color }"
                                                              v-html="decisionItem3.headline">></h4>
                                                        <span v-html="decisionItem3.text"></span>
                                                    </div>
                                                    <p></p>
                                                </div>

                                            <div v-if="evaluationData.decisions.decisionItems4">

                                                    <h4>{{text('api.assessment.headline.di4')}}</h4>
                                                    <div v-for="decisionItem4 in evaluationData.decisions.decisionItems4"  class="font-weight-regular no-margin-bottom">
                                                        <h4   v-bind:style="{'color': decisionItem4.color }"
                                                              v-html="decisionItem4.headline">></h4>
                                                        <span v-html="decisionItem4.text"></span>
                                                    </div>
                                                    <p></p>
                                                </div>

                                        </v-card-text>
                                    </v-card>
                                </v-expansion-panel-content>


                                <v-expansion-panel-content  class="expansion-list comments-container"  v-if="evaluationData.comments && evaluationData.hasScoringData" value="1">
                                    <div slot="header" class="color-headings-text font-size-medium" v-if="evaluationData.comments.commentTexts">
                                        {{text('db.product.PROD_TITLE_RAT')}}
                                    </div>
                                    <v-card>
                                        <v-card-text>

                                            <div v-if="evaluationData.comments.commentTexts">
                                                <p v-for="comment in evaluationData.comments.commentTexts" class="font-weight-regular no-margin-bottom" v-html="comment">
                                                </p>
                                            </div>

                                        </v-card-text>
                                    </v-card>
                                </v-expansion-panel-content>

                                        <v-expansion-panel-content class="expansion-list recommendations-container" v-if="evaluationData.hasScoringData && evaluationData.recommendations.recommendationsSections.length > 0" value="1">

                                    <div slot="header" class="color-headings-text font-size-medium">
                                        {{text('db.product.PROD_TITLE_ADV')}}
                                    </div>
                                    <v-card>
                                        <v-card-text>

                                            <div v-if="evaluationData.recommendations.recommendationsSections">

                                                <div v-for="recommendation in evaluationData.recommendations.recommendationsSections" class="padding-bottom-xs">
                                                    <h4 v-if="recommendation.title && recommendation.recommendationsTexts" class="color-headings-text" v-html="recommendation.title"></h4>

                                                            <ul v-for="recommendationItem in recommendation.recommendationsTexts" class="font-weight-regular">
                                                                <li class="recommendationlist" v-if="recommendationItem.type === 'LIST_ITEM'" v-html="recommendationItem.text"></li>
                                                                <li v-else v-html="recommendationItem.text"></li>
                                                            </ul>
                                                        </div>

                                            </div>

                                                </v-card-text>
                                            </v-card>
                                        </v-expansion-panel-content>

                            </v-expansion-panel>

                        </v-card-text>


                        <v-card-actions class="pf-actions hidden-xs-only">
                            <v-btn flat color="grey darken-1" @click="goToPreviousPage" class="footer-btn">
                                <v-icon>keyboard_arrow_left</v-icon>
                                {{ text('api.button.back') }}
                            </v-btn>
                            <v-btn flat color="primary" @click="goToNextPage"  class="footer-btn footer-btn-next">
                                <!--{{ text('api.button.evaluate')}}-->
                                {{text("api.button.newCase")}}
                                <v-icon>keyboard_arrow_right</v-icon>
                            </v-btn>
                        </v-card-actions>

                    </v-card>

                </v-flex>

            </v-layout>

            <v-layout>
                <v-flex>
                    <div class="footer pf-standard-mobile hidden-sm-and-up">
                            <v-btn flat color="grey darken-1" @click="goToPreviousPage" class="footer-btn back-pf">
                                <v-icon>keyboard_arrow_left</v-icon>
                                {{ text('api.button.back') }}
                            </v-btn>

                            <mobile-stepper  :steps="step"></mobile-stepper>

                            <v-btn flat color="primary" @click="goToNextPage" class="footer-btn footer-btn-next next-pf">
                                {{text("api.button.newCase")}}
                                <v-icon>keyboard_arrow_right</v-icon>
                            </v-btn>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>

    </div>

</template>

<!-- ################################################################## -->

<script>
    import {mapGetters} from 'vuex';
    import HeaderBar from '../../shared/HeaderBar';
    import TopBar from '../../../../common/components/shared/TopBar';
    import AssessmentAlerts from "../../../../common/components/shared/AssessmentAlerts";
    import PatientInfo from "../../../../common/components/shared/PatientInfo";
    import AcceptCookie from '../../../../professional/components/cookies/AcceptCookie';
    import Description from '../../shared/Description';
    import StandardStepper from '../../shared/StandardStepper';
    import MobileStepper from '../../shared/MobileStepper';

    export default {
        name: 'EvaluationPage',
        components: {
            HeaderBar,
            TopBar,
            AssessmentAlerts,
            PatientInfo,
            AcceptCookie,
            Description,
            StandardStepper,
            MobileStepper
        },
        data() {
            return {
                step: 7,
            }
        },

        beforeCreate() {
            this.$store.commit('EvaluationStore/resetStore');
            this.$store.commit('AssessmentAlertsStore/resetStore');
        },

        created() {
            this.$store.dispatch('PfEvaluationStore/loadEvaluationData');
        },

        computed: mapGetters({
            evaluationData: 'PfEvaluationStore/getEvaluationData',
            isLoadingEvaluationData: 'EvaluationStore/getIsLoadingEvaluationData',
            getMustShowAssessmentList: 'SymptomsQuestionsStore/getMustShowAssessmentList',
            getUsedShortcut: 'PfEvaluationStore/getUsedShortcut'
        }),

        methods: {
            // --------- Component methods. ---------
            goToPreviousPage() {
                if(this.getUsedShortcut) {
                    this.$router.push('/pathfinder/general-questions');
                }
                else {
                    this.$router.push('/pathfinder/shared-questions');
                }

                this.$store.commit('ScoringStore/setIsAssessmentSealed', false);
            },

            goToNextPage() {
                this.$router.push('/pathfinder/home');
            }
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>
    .evaluation-card {
        margin-bottom: 25px;

        .card {
            border-radius: 5px;
            padding: 20px 30px !important;
            border-top: none;
            min-height: 600px;

            .card__text {
                border-top: none;

                h2{
                    margin-bottom: 30px;
                    font-size: $font-size-medium;
                    padding-bottom: 10px;
                    border-bottom: 1px solid $color-gray-lightest;
                }

                > div {

                    h4 {
                        margin-bottom: 10px;
                    }

                    p {
                        margin-bottom: 5px;
                    }
                }

                .decision-item {
                    margin-bottom: 15px;
                    padding-bottom: 15px;
                    border-bottom: 1px solid $color-gray-lightest;
                }
            }
        }

    }

    .scrolling-content-evaluation {
        top: 140px;
        position: fixed;
        margin-left: auto;
        margin-right: auto;
        bottom: 70px;
        overflow: auto;
        width: 100%;
        padding-top: 34px
    }

    .topbar-patient-info-content {
        position: fixed;
        right: 125px !important;
    }

    .scrolling-content {
        overflow: hidden !important;
    }

    .scrolling-content.path {
        top: 110px !important;

        .card {
            padding: 0 !important;

            .card__text.recommendations {
                padding: 0 30px;
                height: 500px;
                overflow: auto;
            }
        }
    }

    .expansion-panel .expansion-panel__container.expansion-list {
        border-bottom: 1px solid $color-gray-lightest;
        border-radius: 0 !important;
    }

    .expansion-panel .expansion-panel__container.expansion-list.expansion-panel__container--active {
        border-bottom: none !important;
    }


    @media only screen and (max-width: 600px) {

        .card.pf-evaluation-page {
            padding: 0 !important;

            .recommendations {
                height: calc(100vh - 264px) !important;
                overflow-y: auto;
            }
        }

        .recommendations ul {
            padding: 0 !important;
        }

        .footer-btn-next.next-pf {
            position: absolute;
            right: 0;
            bottom: 4px;
        }

        .footer-btn.back-pf {
            position: absolute;
            top: 4px;
        }

        .pf-standard-mobile {
            .footer-btn-next {
                background-color: $color-block-background;
                color: $color-brand-primary;
            }
        }
    }

    @media only screen and (min-width: 601px) {

        .card.pf-evaluation-page {
            padding: 0 !important;

            .recommendations {
                height: 500px !important;
                overflow-y: auto;
            }

        }

        .recommendations ul {
            padding: 0 25px !important;
        }

        .evaluation-page-pf-content {
            height: calc(100vh - 360px) !important;

            .pf-evaluation-page {
                height: 100% !important;


                .recommendations {
                    height: calc(100% - 60px) !important;
                }

                .pf-actions {
                    height: 60px !important;
                    position: absolute;
                    bottom: 0 !important;
                }
            }
        }

        .evaluation-page-pf {
            margin-top: 30px !important;
        }

        .pf-actions {
            .footer-btn-next {
                background-color: $color-block-background;
                color: $color-brand-primary;
            }
        }
    }

</style>




// WEBPACK FOOTER //
// src/pathfinder/components/standard-forms/evaluation/EvaluationPage.vue